import "./Security.css"

function Security() {

    return (
        <section id="security">
            <div className="sectionBox">
                <div className="security">
                    <nav className="#security">
                        <h1>
                            Cyber Security Consultancy Service
                        </h1>
                        <p>
                        Offering consultancy services, guidance and support for Cyber Security including:
                        </p>
                        <ul>
                            <li>Compliance Readiness</li>
                            <li>Risk Assessment and Risk Management</li>
                            <li>Identity and Access Management</li>
                            <li>Vulnerability Analysis</li>
                            {/* <li>Network Security</li>
                            <li>Sytem Security</li>
                            <li>Cryptography</li>
                            <li>Privacy Enhancing Technologies</li>
                            <li>Cyber Risk Management</li> */}
                        </ul> 
                    </nav>
                </div>
            </div>
        </section>
    );
}

export default Security